module.exports = "<div class=\"uw-issues\">\n    <h3>Titel TBD: ES IST EIN FEHLER AUFGETRETEN</h3>\n    <div class=\"form-close\" ng-click=\"$dismiss()\"></div>\n\n  <div class=\"gw-modal-body\">\n        ID: {{code}} of uw issue will be replaced by magnolia text\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/mfp/views/mfp-uw-issues.html
// module id = 633
// module chunks = 0